<ng-container *ngIf="!isLoading; else spinner">
  <mat-dialog-content [formGroup]="formGroup">
    <mat-radio-group formGroupName="orgType">
      <label>Organization Type: </label>
      <div class="radio-container">
        <mat-radio-button value="1" [checked]="isForProfit" (change)="forProfitChanged($event)">Profit</mat-radio-button>
        &nbsp;
        <mat-radio-button value="2" [checked]="!isForProfit" (change)="forProfitChanged($event)">Not-for-Profit</mat-radio-button>
      </div>
    </mat-radio-group>
    <br>
    <mat-form-field>
      <input matInput
             placeholder="{{memberSizePlaceHolder}}"
             formControlName="aveNumMembers"
             type="number"
             min="0"
             step="1"
             [(ngModel)]="business.flyingClub.clubMembers"
             (focusout)="aveMemberUnfocussed()"/>
    </mat-form-field>
    <br>
    <mat-form-field>
      <input matInput
             placeholder="# of Aircraft"
             formControlName="numOfAC"
             type="number"
             min="0"
             step="1"
             [(ngModel)]="business.flyingClub.clubAircraft"
             (focusout)="numOfACUnfocussed()"/>
    </mat-form-field>
    <br>
    <mat-radio-group class="no-wrap-container" formControlName="membershipsAvail">
      <label>Are Memberships Currently Available?</label>
      <div class="radio-container">
        <mat-radio-button value="1" [checked]="isAvailable" (change)="membershipChanged($event)">Yes</mat-radio-button>
        &nbsp;
        <mat-radio-button value="2" [checked]="!isAvailable" (change)="membershipChanged($event)">No</mat-radio-button>
      </div>
    </mat-radio-group>
    <mat-checkbox [disabled]="isAvailable" (change)="waitingListChecked($event)" [checked]="hasWaitingList" >Waiting List Available</mat-checkbox>
  </mat-dialog-content>

  <mat-dialog-actions class="no-wrap-container">
    <button type="submit" [disabled]="!formGroup.valid" class=" submit-button mat-raised-button" (click)="save()">
      Save
    </button>
    <button id="cancelButton" class="mat-raised-button" (click)="close(null)">Cancel</button>
  </mat-dialog-actions>
</ng-container>
<ng-template id="spinnerContainer" #spinner>
  <mat-dialog-content>
    <mat-spinner class="spinner" [diameter]="100" [color]="'accent'"></mat-spinner>
  </mat-dialog-content>
</ng-template>

